import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const NoDataMessage = ({ classes, imgSrc, imgAlt, message, styles = {}, children, testId }) => (
  <div
    data-testid={testId}
    className={classNames('jisr-NoDataMessage-container', classes && classes.container)}
    style={styles.container}
  >
    {imgSrc && (
      <img
        data-testid="no-data-image"
        className={classNames('jisr-NoDataMessage-img', classes && classes.img)}
        style={styles.img}
        src={imgSrc}
        alt={imgAlt}
      />
    )}
    {message && (
      <span
        data-testid="no-data-message"
        className={classNames('jisr-NoDataMessage-message', classes && classes.message)}
        style={styles.message}
      >
        {message}
      </span>
    )}
    {children}
  </div>
)

NoDataMessage.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape(),
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string,
  message: PropTypes.string,
  styles: PropTypes.shape(),
  testId: PropTypes.string,
}

export default NoDataMessage
